"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/CNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_50)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_50`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.28003 0H30.72V24H-5.28003V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.6358 16.786L9.95507 15.6912L8.69893 16L9.53402 15.0105L8.85331 13.9158L10.0533 14.4L10.8814 13.4105L10.7902 14.7018L11.9902 15.186L10.734 15.4948L10.6358 16.786ZM15.113 5.7544L14.4042 6.8351L15.2182 7.83861L13.9761 7.50177L13.2673 8.58949L13.1972 7.29826L11.9551 6.96142L13.1621 6.49826L13.0919 5.20703L13.9059 6.21054L15.113 5.7544ZM11.2954 1.78247L11.1551 3.06668L12.334 3.60001L11.0709 3.86668L10.9305 5.15089L10.2849 4.02808L9.02875 4.29475L9.89191 3.33335L9.2463 2.21756L10.4252 2.74387L11.2954 1.78247ZM15.2673 11.3544L14.2217 12.1193L14.6288 13.3474L13.5831 12.5895L12.5375 13.3614L12.9305 12.1263L11.8849 11.3755L13.1761 11.3684L13.5691 10.1333L13.9761 11.3614L15.2673 11.3544ZM2.79016 3.24914L4.00419 7.00352H7.94805L4.76209 9.31229L5.97612 13.0667L2.79016 10.7509L-0.402826 13.0667L0.818227 9.31229L-2.37476 7.00352H1.57612L2.79016 3.24914Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_50`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as CNFlag };
